import { doorClient, ImResponse, resolve, storeHomeClient } from '.';
import { ossUpload } from './uploads';

/**
 * @description 1 image,2 video
 */
type ResourceType = 1 | 2;

export interface UploadVideoVo {
  resourceId: string;
  videoUrl: string;
  localVideoUrl: string;
  thumbUrl: string;
  durationSeconds: number;

  /**
   * 1:已上传到本地,2:开始上传到平台,3:已上传到官方，转码中,4:官方合成完毕,5:官方转码失败,6:官方过期,重新上传中
   */
  state: Resource.UploadState;
  externalVideoId?: string;
  resourceCentreId?: string;
}

export interface QueryHistoryResourceParams {
  keyword?: string;

  // resourceType: ResourceType;
  storeId: string;
  page: {
    pageNo: number;
    pageSize: number;
  };
}

export interface HistoryResource {
  keyword: string;
  targetType: ResourceType;
  targetId: string;
  textVideoContent?: Conversation.MsgTextVideo;
  videoContent?: Conversation.MsgVideo;
  sendCount: number;
}

export interface QueryHistoryMediaRet {
  total: number;
  data: HistoryResource[];
}

export const queryHistoryResourceList = (params: QueryHistoryResourceParams) => {
  return resolve(
    doorClient.post<ImResponse<QueryHistoryMediaRet>>(
      '/overseaim-hi/userSendHistory/query',
      params,
      {},
    ),
  );
};

export const checkResourceIsExpired = async (id: string): Promise<UploadVideoVo> => {
  return resolve(storeHomeClient.get(`/upload/checkExists?resourceId=${id}`));
};

interface UploadFileV1Params {
  storeId?: string;
  storeGroupId?: string;
  region?: General.UpperCaseRegion;
  file: File;
  channel?: string;
  uploadResourceCentre?: boolean;
  externalConversationId?: string;
}

export const uploadFile = async (params: UploadFileV1Params): Promise<UploadVideoVo> => {
  const {
    storeId,
    storeGroupId,
    region,
    file,
    channel,
    uploadResourceCentre,
    externalConversationId,
  } = params;

  if (channel === 'WA_BIZ') {
    return ossUpload({
      file,
    }).then((res) => {
      return {
        ...res,
        state: 4,
      };
    });
  }

  return ossUpload({
    file,
    storeId,
    storeGroupId,
    region,
    externalConversationId,
    uploadResourceCentre,
    uploadAllPlatform: uploadResourceCentre,
    uploadPlatform: Boolean(storeId) || uploadResourceCentre,
  }).then(({ state, ...others }) => {
    return {
      ...others,
      state: state === 8 ? 4 : state === 12 ? 5 : 2,
    };
  });
};

interface UploadFileV2Params {
  storeId?: string;
  region?: General.UpperCaseRegion;
  file: File;
  uploadResourceCentre?: boolean;
  externalConversationId?: string;
}

export const uploadFileV2 = async (params: UploadFileV2Params): Promise<UploadVideoVo> => {
  const { storeId, region, file, uploadResourceCentre, externalConversationId } = params;

  return ossUpload({
    file,
    storeId,
    region,
    externalConversationId,
    uploadPlatform: Boolean(storeId) || uploadResourceCentre,
    uploadResourceCentre,
    uploadAllPlatform: uploadResourceCentre,
  }).then(({ state, ...others }) => {
    return {
      ...others,
      state: state === 8 ? 4 : state === 12 ? 5 : 2,
    };
  });
};

export const uploadExcel = async (file: File) => {
  return ossUpload({
    file,
    fileType: 'XLSX',
  }).then(({ localVideoUrl }) => {
    return { url: localVideoUrl };
  });
};

export interface UploadFileByURLBody {
  storeId: string;
  resourceType: 'IMAGE' | 'VIDEO';
  url: string;
}

export interface UploadFileByURLData {
  id: number;
  url: string;
  localUrl: string;
  thumbUrl: string;
  videoDuration: number;
  resourceState: number;
  resourceType: ResourceType;
  externalVideoId?: string;
  mimeType?: string;
}

export const uploadFileByURL = (body: UploadFileByURLBody) => {
  return storeHomeClient.post<ImResponse<UploadFileByURLData>>('/upload_file_by_url', body);
};
